var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiSnackBar from "@material-ui/core/Snackbar";
import { Alert, getSeverityForAppearance } from "../alert/alert";
/** @deprecated use `severity` instead */
var deprecatedAppearanceProp = "appearance";
var autoHideDurationDefaults = {
    error: 8000,
    warning: 8000,
    success: 5000,
    info: 5000,
    default: 5000,
};
export var Toast = React.forwardRef(function (props, ref) {
    var action = props.action, appearance = props.appearance, propAutoHideDuration = props.autoHideDuration, children = props.children, dismissible = props.dismissible, message = props.message, onClose = props.onClose, onDismiss = props.onDismiss, propSeverity = props.severity, title = props.title, icon = props.icon, _a = props.AlertProps, AlertProps = _a === void 0 ? {} : _a, snackbarProps = __rest(props, ["action", "appearance", "autoHideDuration", "children", "dismissible", "message", "onClose", "onDismiss", "severity", "title", "icon", "AlertProps"]);
    var severity = propSeverity || getSeverityForAppearance(appearance) || "default";
    // allow null to disable autoHide
    var autoHideDuration = propAutoHideDuration !== null ? propAutoHideDuration || autoHideDurationDefaults[severity] : null;
    return (React.createElement(MuiSnackBar, __assign({ autoHideDuration: autoHideDuration, onClose: onClose, ref: ref }, snackbarProps), children || (React.createElement(Alert, __assign({ elevation: 4, severity: severity, title: title, icon: icon, onClose: onClose ? function (event) { return onClose(event, "closeClick"); } : undefined, action: action, dismissible: dismissible, onDismiss: onDismiss, variant: "outlined" }, AlertProps), message))));
});
// tslint:enable: no-empty-interface
/** @deprecated use `Toast` instead */
export var SnackBar = Toast;
